import React, { useEffect, useState } from "react";
import { Modal, Fade, Box } from "@mui/material";
import PopupFrame from "../../Popups/PopupFrame/PopupFrame";
import HeaderTitle from "../HeaderTitle/HeaderTitle";
import DPasswordInput from "../../Dashboard/DashboardInputs/DPasswordInput";
import DButton from "../../Dashboard/DashboardButtons/Dbutton";
import DButtonOutlined from "../../Dashboard/DashboardButtons/dButtonOutlined";
import {
  emptyCheck,
  validateConfirmPassword,
  validatePassword,
} from "../../../utils/validations";
import axios from "axios";
import { API_ENDPOINT } from "../../../services/api/resources";
import { useSelector } from "react-redux";
import styles from "./ProfileCard.module.css";

import FingerprintJS from "@fingerprintjs/fingerprintjs";
import SuccessPopupDashboard from "../../Popups/PopupFrame/SuccessPopupDashboard";
import successPopupImg from "../../../assets/images/png/Group 2 2@2x.png";
import FailurePopupImg from "../../../assets/images/png/Group 2@2x.png";
import { offlinePasswordRepository } from "../../../offline/repositories/offlinePassword.repository";
import { verifyPBKDF2 } from "../../../offline/utils/passwordVerifier";
import LoginHeader from "../../Login/LoginHeader/LoginHeader";

const OfflinePasswordModal = ({ open, onClose, mode = "create" }) => {
  const loginData = useSelector((state) => state.loginData.value);
  const auth_token = loginData?.auth_token;
  console.log(loginData?.access_type);
  const [loading, setLoading] = useState(false);
  const [openS, setOpenS] = useState(false);
  const [openF, setOpenF] = useState(false);
  const [noPassword, setNoPassword] = useState(false);
  const handleOpenS = () => setOpenS(true);
  const handleCloseS = () => {
    setOpenS(false);
  };
  const handleOpenF = () => setOpenF(true);

  const handleCloseF = () => {
    setOpenF(false);
    setNoPassword(false);
  };

  const [password, setPassword] = useState({
    value: "",
    isValid: true,
  });

  const [confirmPassword, setConfirmPassword] = useState({
    value: "",
    isValid: true,
  });

  const inputs =
    mode === "create"
      ? [
          <DPasswordInput
            key="new"
            label="New Password"
            type="password"
            value={password.value}
            onChange={(e) => {
              let val = e.target.value;
              setPassword({
                value: val,
                isValid: validatePassword(val),
              });
            }}
            error={!password.isValid}
            errorMsg={
              !emptyCheck(password.value)
                ? "New Password is required"
                : !password.isValid
                  ? "Invalid password"
                  : ""
            }
            customWrapperClass={styles.pwds}
            size="44%"
            info
          />,

          <DPasswordInput
            key="confirm"
            label="Confirm Password"
            type="password"
            onChange={(e) => {
              let val = e.target.value;
              setConfirmPassword({
                value: val,
                isValid: emptyCheck(val),
              });
            }}
            error={!confirmPassword.isValid}
            errorMsg={
              !emptyCheck(confirmPassword.value)
                ? "Confirm Password is required"
                : !confirmPassword.isValid
                  ? "Password doesn't match"
                  : ""
            }
            customWrapperClass={styles.pwds}
            value={confirmPassword.value}
            confirmPassword
            comparePassword={password.value}
            size="44%"
          />,
        ]
      : [
          <DPasswordInput
            key="offline"
            label="Offline Password"
            type="password"
            value={password.value}
            onChange={(e) =>
              setPassword({ value: e.target.value, isValid: true })
            }
            error={!emptyCheck(password.value)}
            errorMsg={!emptyCheck(password.value) ? "Password is required" : ""}
            customWrapperClass={styles.pwds}
            size="100%"
          />,
        ];

  const validateForm = () => {
    const passValid = validatePassword(password.value);
    const confirmValid =
      validateConfirmPassword(password.value, confirmPassword.value) &&
      emptyCheck(confirmPassword.value);

    setPassword((p) => ({ ...p, isValid: passValid }));
    setConfirmPassword((p) => ({ ...p, isValid: confirmValid }));

    return passValid && confirmValid;
  };

  const getDeviceId = async () => {
    let deviceId = localStorage.getItem("device_id");

    if (deviceId) return deviceId;

    const fp = await FingerprintJS.load();
    const result = await fp.get();

    deviceId = result.visitorId;
    localStorage.setItem("device_id", deviceId);
    return deviceId;
  };

  useEffect(() => {
    getDeviceId();
  }, []);

  const handleSubmit = async () => {
    if (!emptyCheck(password.value)) return;

    if (mode === "create" && !validateForm()) return;
    if (mode !== "create" && !emptyCheck(password.value)) return;
    setLoading(true);

    try {
      if (mode === "create") {
        const deviceId = await getDeviceId();

        await axios.post(
          API_ENDPOINT.offline_password_create,
          {
            user_type:
              loginData?.access_type === "vendor admin" ||
              loginData?.access_type === "vendor contact"
                ? "vendor"
                : "organization",

            user_token: loginData?.user?.user_token,
            device_id: deviceId,
            password: password.value,
          },
          {
            headers: {
              Authorization: `Bearer ${auth_token}`,
            },
          },
        );

        await offlinePasswordRepository.syncFromAPI(
          auth_token,
          loginData?.user?.user_token,
          deviceId,
          loginData?.access_type === "vendor admin" ||
            loginData?.access_type === "vendor contact"
            ? "vendor"
            : "organization",
        );
        setPassword({ value: "", isValid: true });
        setConfirmPassword({ value: "", isValid: true });

        onClose();
        handleOpenS();
      } else {
        const deviceId = await getDeviceId();
        console.log(deviceId);
        const passwords = await offlinePasswordRepository.getFromCache(
          loginData.user.user_token,
          deviceId,
        );
        console.log(passwords);
        if (!passwords.length) {
          setNoPassword(true);
          setLoading(false);
          return;
        }

        const storedHash = passwords[0].password_hash;
        console.log(storedHash);
        const valid = await verifyPBKDF2(password.value, storedHash);
        console.log(valid);
        if (valid) {
          localStorage.setItem("offline_verified", "true");
          onClose();
          setPassword({ value: "", isValid: true });
        } else {
          handleOpenF();
        }
      }
    } catch (err) {
      console.log(err);
    }
    setLoading(false);
  };

  const actions =
    mode === "create"
      ? [
          <DButtonOutlined label="Cancel" onClick={onClose} />,
          <DButton
            label="Save"
            loadingState={loading}
            onClick={handleSubmit}
          />,
        ]
      : [
          <DButton
            label="Verify & Continue"
            loadingState={loading}
            onClick={handleSubmit}
            customClass={styles.fullBtn}
          />,
        ];

  return (
    <>
      <Modal open={open} closeAfterTransition>
        <Fade in={open}>
          <div className={styles.flex} style={{ height: "100vh" }}>
            <PopupFrame
              customClass={styles.settingsPopup}
              inputChildren={inputs}
              poupHeading={
                <div className={styles.offlineHeader}>
                  <LoginHeader
                    infoText={
                      mode === "create"
                        ? "Create a password for offline access"
                        : "Enter your offline password to continue"
                    }
                  />
                </div>
              }
              actionButtons={actions}
              closePopup={onClose}
            />
          </div>
        </Fade>
      </Modal>

      <Modal open={openS}>
        <Fade in={openS}>
          <Box>
            <SuccessPopupDashboard
              popupImage={successPopupImg}
              popupHeroText={
                <>
                  Password Created <br /> Successfully!
                </>
              }
              // popupDescription={}
              popBtn={true}
              btnText={"Okay"}
              btnClick={handleCloseS}
            />
          </Box>
        </Fade>
      </Modal>

      <Modal open={openF}>
        <Fade in={openF}>
          <Box>
            <SuccessPopupDashboard
              popupImage={FailurePopupImg}
              popupHeroText={<>Incorrect Password</>}
              // popupDescription={}
              popBtn={true}
              btnText={"Okay"}
              btnClick={handleCloseF}
            />
          </Box>
        </Fade>
      </Modal>

      <Modal open={noPassword}>
        <Fade in={noPassword}>
          <Box>
            <SuccessPopupDashboard
              popupImage={FailurePopupImg}
              popupHeroText={
                <>
                  Offline Password not available <br />
                  Create Offline Password in Online
                </>
              }
              // popupDescription={}
              popBtn={true}
              btnText={"Okay"}
              btnClick={handleCloseF}
            />
          </Box>
        </Fade>
      </Modal>
    </>
  );
};

export default OfflinePasswordModal;
